import moment from "moment";

export const basicForm = {
  e: null,
  name: "",
  slug: "",
  daterange: [
    moment().format("YYYY-MM-DD HH:mm"),
    moment().format("YYYY-MM-DD HH:mm")
  ],
  selldaterange: [
    moment().format("YYYY-MM-DD HH:mm"),
    moment().format("YYYY-MM-DD HH:mm")
  ],
  pro_name: "",
  pro_short: "",
  pro_type: "",
  intro: "",
  pro_shortdesc: "",
  pro_longdesc: "",
  shortdesc: "",
  longdesc: "",
  timezone: "Asia/Bangkok",
  venue: "",
  speaker_url: "",
  poster: "",
  mode: null,
  freeevent: null,
  privacy: null,
  private_token: null,
  instruction: "",
  lobby_intro: "",
  fields_status: null,
  featured_status: 0,
  wht_status: false,
  wht_vat: null,
  digitalinvoice: false,
  pay_deadline: null,
  taxinv_instruction: null,
  taxinv_status: null,
  taxinv_prefix: "",
  taxinv_onrequest: null,
  taxinv_supportno: "",
  currency: null,
  altcurrencycode: null,
  altcurrencyrate: null,
  terms_require: 0,
  terms: "",
  landingpage: "",
  remark: "",
  freecode: "",
  invitetext: "",
  tickettransfer: 1,
  refundpolicy: "",
  norefund: "",
  waitlist: "",
  gaid: "",
  fbpid: "",
  awcid: "",
  awclabel: "",
  code_footer: "",
  zapier_status: null,
  zapier_webhook: "",
  max_attendee: "",
  engnameonly: "",
  weight: "",
  pay_creditcard: 1,
  pay_transfer: 1,
  fee: "",
  int_invoiceno: "",
  int_invoicedate: "",
  int_remark: "",
  enable_child_sessions: "",
  trash_status: 0,
  related_product_ids: "",
  related_event_ids: "",
  keywords: "",
};

export const assetForm = {
  txtcolor: "",
  bgcolor: "",
  font: ""
};

export const currencyForm = {
  currency: "THB",
  hasReference: false,
  altcurrencycode: "USD",
  altcurrencyrate: null
};

export const liveForm = {
  live_engine: "",
  live_engine2: "",
  join_url: "",
  rerun_status: "",
  zoom_status: "",
  zoom_account_no: "",
  zoom_webinar_id: "",
  zoom_session_type: "",
  vimeo_playback_url: "",
  dacast_playback_url: "",
  ivs_creator_endpoint_url: "",
  ivs_creator_stream_key: "",
  ivs_viewer_endpoint_url: "",
  ivs_channel_id: "",
  ivs_playback_url: "",
};

export const contactForm = {
  supportno: "",
  lineid: "",
  lineaddurl: "",
  fbpage: ""
};

export const advanceForm = {
  max_attendee: "",
  engnameonly: "",
  freecode: "",
  weight: "",
  pay_creditcard: "1",
  pay_transfer: "1",
  pay_deadline: "",
  zapier_status: "",
  zapier_webhook: "",
  remark: "",
  fee: "",
  int_invoiceno: "",
  int_invoicedate: "",
  int_remark: "",
  enable_child_sessions: "",
  trash_status: 0
};

export const ticketForm = {
  poster: "",
  product_id: null,
  pro_name: "",
  pro_shortname: "",
  pro_shortdesc: "",
  pro_longdesc: "",
  qty: 0,
  price: 0,
  fullprice: 0,
  selldate_start: moment().format("YYYY-MM-DD HH:mm"),
  selldate_end: moment().format("YYYY-MM-DD HH:mm"),
  requiredqty: 1,
  minqty: 1,
  maxqty: 1,
  publish_status: 1,
  listing_status: 1,
  featured_status: 0,
  weight: 0,
  role: "attendee",
  remain_quantity: 0,
  mode: 0,
  sell_status: "open",
  groupslug: "",
  pro_group: "",
  ticket_note:"",
  soldout: null
};

export const bootsalesForm = {
  promotext: "",
  countdown: 0,
  countdowntext: "",
  soldbar: 0,
  soldbar_start: moment().format("YYYY-MM-DD HH:mm"),
  soldbar_end: moment().format("YYYY-MM-DD HH:mm"),
  socialproof: 0,
  exitpopup: 0,
  exitpopuptext: "",
  friendgetfriend: 1,
  invitetext: "",
  bootSaleRange: [
    moment().format("YYYY-MM-DD HH:mm"),
    moment().format("YYYY-MM-DD HH:mm")
  ],
};
